import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import {Button, TextField} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {useState} from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {updateObject} from "../../../../utils/updateObject";
import DefaultSelect from "../../../../../components/ui/inputs/selects/default-select/DefaultSelect";
import {typeSimFilterItems} from "./FilterDialogHelper";
import {getHowManyFiltersApplied} from "../../../../utils/utils";
import GenericDialog from "../../../../../components/ui/dialogs/generic-dialog/GenericDialog";
import {useSelector} from "react-redux";
import AutocompleteWithoutIcon
    from "../../../../../components/ui/autocompletes/autocomplete-without-icon/AutocompleteWithoutIcon";

const FilterDialog = (props) => {
    const [currentFilters, setCurrentFilters] = useState(props.filter)
    const [collaboratorAutocompleteInput, setCollaboratorAutocompleteInput] = useState("");

    const collaborators = useSelector(state => state.contrattoDigitaleReducer.simFilterCollaborators.data)
    const collaboratorsLoading = useSelector(state => state.contrattoDigitaleReducer.simFilterCollaborators.loading)

    const handleApplyFilters = () => {
        props.handleFilterSearch(currentFilters)
        props.handleDialogClose()
    }

    const handleChange = (e) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter,
            {
                [e.target.name]: updateObject(prevCurrentFilter[e.target.name],
                    {value: e.target.name !== "collaborators" ? e.target.value : [e.target.value]})
            }))
    }

    const handleCollaboratorsChange = (values) => {
        setCollaboratorAutocompleteInput("")
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter,
            {
                collaborators: updateObject(prevCurrentFilter.collaborators,
                    {value: values})
            }))
    }

    const handleCollaboratorSearch = (e) => {
        setCollaboratorAutocompleteInput(e.target.value)
    }

    const dialogContent = (
        <>
            <Typography variant="h5">
                Filtri
            </Typography>

            <Grid container
                  justifyContent="center"
                  alignItems="center">
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle2">
                        Tipologia SIM
                    </Typography>
                </Grid>

                <Grid item
                      xs={12} sm={7} md={8}>
                    <DefaultSelect menuItems={typeSimFilterItems}
                                   value={currentFilters.tipologiaSim.value}
                                   handleOnChange={handleChange}
                                   label="Tipologia"
                                   name="tipologiaSim"
                                   fullWidth
                                   hasEmptyItem/>
                </Grid>
            </Grid>

            <Grid container
                  justifyContent="center"
                  alignItems="center">
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle2">
                        Piano
                    </Typography>
                </Grid>

                <Grid item
                      xs={12} sm={7} md={8}>
                    <TextField onChange={handleChange}
                               value={currentFilters.piano.value}
                               type="text"
                               label="Nome Piano"
                               name="piano"
                               fullWidth/>
                </Grid>
            </Grid>

            <Grid container
                  justifyContent="center"
                  alignItems="center">
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle2">
                        Collaboratori
                    </Typography>
                </Grid>

                <Grid item
                      xs={12} sm={7} md={8}>
                    <AutocompleteWithoutIcon placeholder="Seleziona collaboratori"
                                             bgColor="#7c92a5"
                                             searchText={collaboratorAutocompleteInput}
                                             setSearchText={handleCollaboratorSearch}
                                             allItems={collaborators}
                                             loading={collaboratorsLoading}
                                             selectedItems={currentFilters.collaborators.value}
                                             setSelectedItems={handleCollaboratorsChange}/>
                </Grid>
            </Grid>
        </>
    )

    const dialogActions = (
        <Grid container
              justifyContent="space-between">
            <Button variant="outlined"
                    color="primary"
                    onClick={props.handleDialogClose}>
                Annulla
            </Button>

            <Button variant="contained"
                    disabled={!getHowManyFiltersApplied(currentFilters)}
                    onClick={handleApplyFilters}
                    color="primary">
                Applica {getHowManyFiltersApplied(currentFilters) ?
                `(${getHowManyFiltersApplied(currentFilters)})` : null}
            </Button>
        </Grid>
    )

    return (
        <GenericDialog dialogWidth="md"
                       open={props.open}
                       handleDialogClose={props.handleDialogClose}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogContent={dialogContent}
                       dialogActions={dialogActions}
                       loading={false}>
            <Button variant="text"
                    color="primary"
                    onClick={props.handleDialogClose}
                    startIcon={<ArrowBackIosIcon fontSize="small"/>}>
                Indietro
            </Button>
        </GenericDialog>
    )
}

FilterDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    handleFilterSearch: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired
}

export default FilterDialog
